import {Inject, Injectable} from '@angular/core';
import { CoreResponse } from '@models/app/response/CoreResponse';
import { PatientConsultationQueryParams } from '@models/data/patient-consultations/interfaces/PatientConsultationQueryParams';
import { Observable } from 'rxjs';
import { PatientConsultationFormData } from '@models/data/patient-consultations/interfaces/PatientConsultationFormData';
import { RequestService } from '@services/http/request/request.service';
import {APP_CONFIG, AppConfig} from '@src/app.config';
import { IPatientConsultationCreateData } from '@src/app/shared/models/data/patient-consultations/interfaces/IPatientConsultationCreateData';
import { PatientConsultation } from '@src/app/shared/models/data/patient-consultations/PatientConsultation';

@Injectable({
  providedIn: 'root',
})
export class PatientConsultationHttpService {
  baseEndpoint = this.appConfig.angularEndpoint + '/patientConsultation';

  private endpoints = {
    listFromSpecificTenant: (tenantId) =>
      `${this.baseEndpoint}/fromSpecificTenant/${tenantId}`,
    getFromSpecificTenant: (id, tenantId) =>
      `${this.baseEndpoint}/${id}/fromSpecificTenant/${tenantId}`,
    listRibbonFromSpecificTenant: (tenantId) =>
      `${this.baseEndpoint}/ribbonFromSpecificTenant/${tenantId}`,
    createInTenant: (tenantId) =>
      `${this.baseEndpoint}/inSpecificTenant/${tenantId}`,
    updateInTenant: (patientConsultId, tenantId) =>
      `${this.baseEndpoint}/${patientConsultId}/inSpecificTenant/${tenantId}`,
    createInNullTenant: `${this.baseEndpoint}/inNullTenant`,
  };

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig, private reqService: RequestService) {}

  /// Creates a new consultation note in the null tenant
  createInNullTenant(data: IPatientConsultationCreateData): Observable<CoreResponse> {
    return this.reqService.post(
      this.endpoints.createInNullTenant,
      data
    );
  }

  /// gets a list of consultation notes (from null tenant)
  getList(patientFitMedProfileId: string): Observable<CoreResponse<PatientConsultation[]>> {
    return this.reqService.get(
      this.baseEndpoint,
      {patientFitMedProfileId}
    );
  }

  listFromSpecificTenant(
    queryParams: PatientConsultationQueryParams,
    tenantId
  ): Observable<CoreResponse> {
    return this.reqService.get(
      this.endpoints.listFromSpecificTenant(tenantId),
      queryParams
    );
  }

  getFromSpecificTenant(id: string, tenantId): Observable<CoreResponse> {
    return this.reqService.get(
      this.endpoints.getFromSpecificTenant(id, tenantId)
    );
  }

  listRibbonFromSpecificTenant(
    queryParams: PatientConsultationQueryParams,
    tenantId
  ): Observable<CoreResponse> {
    return this.reqService.get(
      this.endpoints.listRibbonFromSpecificTenant(tenantId),
      queryParams
    );
  }

  createInTenant(
    formData: PatientConsultationFormData,
    tenantId: string
  ): Observable<CoreResponse> {
    return this.reqService.post(
      this.endpoints.createInTenant(tenantId),
      formData
    );
  }

  updateInTenant(
    patientConsultId: string,
    formData: PatientConsultationFormData,
    tenantId: string
  ): Observable<CoreResponse> {
    return this.reqService.put(
      this.endpoints.updateInTenant(patientConsultId, tenantId),
      formData
    );
  }
}
